import { render, staticRenderFns } from "./SharedBookmarkPage.vue?vue&type=template&id=596aeeca&scoped=true"
import script from "./SharedBookmarkPage.vue?vue&type=script&lang=js"
export * from "./SharedBookmarkPage.vue?vue&type=script&lang=js"
import style0 from "./SharedBookmarkPage.vue?vue&type=style&index=0&id=596aeeca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596aeeca",
  null
  
)

export default component.exports